<script lang="ts">
    
    import { fly } from 'svelte/transition';
    import { navigate } from "svelte-navigator";
    import LottiePlayer from "../Components/LottiePlayer.svelte";
    import Slide from "../Components/Slide.svelte";
    import Slider from "../Components/Slider.svelte";
    import { avatars } from "../environment";
    import { avatar } from "../Services/avatar";
    import Audio from '../Components/Audio.svelte';
    import type { Fn } from '../global';
    import { getContext, onMount } from 'svelte';

    const playMainTheme: Fn = getContext('playMainTheme');

    let slider: Slider;
    let activeIndex: number;
    let isFirst = false;
    let isLast = false;
    let wooshSound: Audio;

    let clientHeight: number

    // $: if (wooshSound) wooshSound.volume = 0.25;
    $: {
        $avatar = avatars[activeIndex] || null;
        isFirst = activeIndex === 0;
        isLast = activeIndex === avatars.length - 1;
    }

    $: setBackgroundColor()

    onMount(playMainTheme);

    function onGo(): void {
        navigate('trivial');
    }

    function onTransitionstart(): void {
        wooshSound?.play();
    }

    function setBackgroundColor() {
        const doc = document.getElementsByTagName('body');

        if(!doc || doc.length == 0) return;

        doc[0].style.backgroundColor = '#4D373D';
    }

</script>

<style lang="scss">

    @use '../variables';

    .title {
        padding: 2rem;
        text-align: center;
        text-transform: uppercase;
        color: #fff;
        font-size: calc(1.5vh + 1.5vw);
        font-family: var(--font-poppins) !important;

        @media screen and (max-width: 620px) {
            font-size: calc(2vh + 2vw);
            padding: 1rem;
        }
    }

    .slider {
        flex: 1 1 0;
        position: relative;
        min-height: 0;
        padding: 1rem 0;
        display: flex;
        flex-direction: column;
    }

    .nav-btn {
        $size: 30px;
        position: absolute;
        z-index: 2;
        width: $size;
        height: $size;
        top: calc(50% - #{$size * 0.5});
        padding: 0;
        background-color: transparent;
        border: none;

        &:disabled {
            opacity: 0.4;
        }
    }

    .prev-btn {
        left: 1rem;

        img {
            transform: scaleX(-1);
        }
    }

    .next-btn {
        right: 1rem;
    }

    .pages {
        display: flex;
        justify-content: center;
        gap: 0.5rem;
    }

    .page {
        $size: 10px;
        width: $size;
        height: $size;
        box-sizing: border-box;
        border-radius: 50%;
        background-color: #fff;
        opacity: 0.4;

        &.current {
            opacity: 1;
        }
    }

    .go-btn {
        display: block;
        width: calc(100% - 2rem);
        padding: 0.5rem;
        margin: 1rem;
        background-color: variables.$answer-win-color;
        border-radius: 1000rem;
        color: #fff;
        font-size: calc(2vh + 2vw);
        font-family: var(--font-londrina) !important;
        letter-spacing: 0.1rem;
        border: none !important;
    }

    .img-container {
        // padding: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: auto; /* Let it adapt to content */
        min-height: 100%; /* Ensures it fills parent height */
        overflow: hidden; /* Prevents overflow */
        width: 100%;
    }

    /* .avatar-container {
        // flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        object-fit: contain;
    } */

    .avatar-text, .avatar {
        object-fit: contain;
        max-width: 100%; /* Ensures images don’t exceed container */
        width: auto;
        height: auto;
        display: block; /* Remove extra spacing from inline elements */
    }

    .avatar {
        margin-top: -5.5vh;
    }

    .avatar-text {
        max-height: 10vh; /* Constrain text image height */
        max-width: 300px;
        animation: float 1.5s ease-in-out infinite;
        z-index: -1;
    }

    @keyframes float {
        0% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-20px);
        }

        100% {
            transform: translateY(0);
        }
    }

    .avatar-name {
        margin-top: calc(2vh + 2vw);
        color: #fff;
        font-size: calc(1.8vh + 1.8vw);
        font-family: var(--font-poppins) !important;
        width: 100%;
        text-align: center;
    }

</style>

<Audio bind:this={wooshSound} src="sound/woosh.mp3" volume={0.4} />

<div class="view">
    <div class="title" in:fly={{ y: -100 }}>
        Selecciona la dificultad
    </div>
    <div class="slider" style="--height: 100%;">
        <Slider bind:this={slider} bind:activeIndex on:transitionstart={onTransitionstart}>
            {#each avatars as avatar, i}
                <!-- <Slide index={avatar}>
                    <LottiePlayer src={avatar.lottieSrc} />
                </Slide> -->
                <Slide>
                    <div class='img-container'>
                        <img src={avatar.textImg} alt='' class='avatar-text' />
                        <img src={avatar.lottieSrc} alt='' class='avatar' style={i == 0 ? 'max-height: 30vh;' : 'max-height: 45vh;'} />

                        <span class='avatar-name'>
                            {#if avatar.name == 'novato'}
                                NIVEL NOVATO
                            {:else}
                                NIVEL REALEJERO PRO
                            {/if}
                        </span>
                        <!-- <div>
                            <img src={avatar.textImg} alt='' class='{i == 0 ? 'avatar-text' : 'avatar-text-2'}' />
                            <img src={avatar.lottieSrc} alt='' class='{i == 0 ? 'img-height-40 avatar' : 'img-height-60 avatar-2'}' />

                            <span class='avatar-name'>
                                {#if avatar.name == 'novato'}
                                    NIVEL NOVATO
                                {:else}
                                    NIVEL REALEJERO PRO
                                {/if}
                            </span>
                        </div> -->
                    </div>  
                </Slide>
            {/each}
        </Slider>
        <button in:fly={{ x: -100 }} type="button" class="nav-btn prev-btn shadow" disabled={isFirst} on:click={() => slider?.prev()}>
            <img src="images/nav-btn.svg" alt="<">
        </button>
        <button in:fly={{ x: 100 }} type="button" class="nav-btn next-btn shadow" disabled={isLast} on:click={() => slider?.next()}>
            <img src="images/nav-btn.svg" alt=">">
        </button>
    </div>
    <div class="pages">
        {#each avatars as avatar, index}
            <div class="page" class:current={activeIndex === index}></div>
        {/each}
    </div>
    <button in:fly={{ y: 100 }} class="go-btn" on:click={onGo}>¡EMPEZAR!</button>
</div>
